import $store from '@/store'
import { getRedirectUri } from '@/util'

export default async (to, from, next) => {
  const isAuthenticated = $store.getters['auth/isAuthenticated']

  // 비인증 사용자 처리
  if (!isAuthenticated) {
    // 메인 페이지는 랜딩으로
    if (to.name === 'main') {
      const landingUrl = process.env.common?.landingUrl
      if (landingUrl) {
        window.location.replace(landingUrl)
        return
      }
    }

    // 인증 필요한 페이지는 로그인으로
    if (to?.meta?.requireSignin !== false) {
      next({ path: `/signin?redirectUri=${getRedirectUri(to)}` })
      return
    }
  }

  next()
}
